import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}><g transform="translate(1.5 -.25)"><rect x="1.453" y="3.439" width="17.883" height="17.708" rx="3.5" stroke="currentColor" /><circle cx="17.127" cy="5.682" r="5.31" fill="#DA5050" /></g></svg>);